import { render, staticRenderFns } from "./CourseContentManage.vue?vue&type=template&id=383dcafc"
import script from "./CourseContentManage.vue?vue&type=script&lang=js"
export * from "./CourseContentManage.vue?vue&type=script&lang=js"
import style0 from "./CourseContentManage.vue?vue&type=style&index=0&id=383dcafc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports